// Reference: https://developer.mixpanel.com/docs/javascript

export const mixpanelConfig = {
    debug: true,
    loaded: () => {
        console.log('Mixpanel loaded')
    },
    verbose: !import.meta.env.PROD
}
